import { render, staticRenderFns } from "./votingPic.vue?vue&type=template&id=7064518a&scoped=true&"
import script from "./votingPic.vue?vue&type=script&lang=js&"
export * from "./votingPic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064518a",
  null
  
)

export default component.exports